import React, { useCallback } from 'react';
import { useUser } from '../../hooks/useUser';
import { useSocialAuth, SocialAuthProvider } from '../../hooks/useSocialAuth';
import { useSocialAccountConnection } from '../../hooks/useSocialAccountConnection';
import { useCountry } from '../CountrySelector';
import { PaymentSourceButton, PaymentSourceButtonProps } from './PaymentSourceButton';

type Props = Partial<PaymentSourceButtonProps> & {
  onSelect?: () => void;
  handleRedirect?: () => void;
  isLoading?: boolean;
};

export const AmazonPayButton: React.FC<Props> = ({
  onSelect,
  handleRedirect,
  isLoading = false,
  ...rest
}) => {
  const {
    country: { currencyCode }
  } = useCountry();
  const {
    user: { isLoggedIn }
  } = useUser();

  const { handleLogin, renderModals } = useSocialAuth(SocialAuthProvider.Amazon, onSelect);

  const { handleConnect, loading: amazonLoading } = useSocialAccountConnection(
    SocialAuthProvider.Amazon
  );

  const handleClick = useCallback(async () => {
    if (isLoggedIn) {
      await handleConnect();
      await onSelect?.();
      handleRedirect?.();
    } else {
      handleLogin();
      handleRedirect?.();
    }
  }, [isLoggedIn, onSelect, handleLogin, handleConnect, handleRedirect]);

  if (currencyCode !== 'USD') return null;

  return (
    <>
      <PaymentSourceButton
        {...rest}
        label="Amazon Pay"
        image="/dist/public/amazon_pay.png"
        loading={amazonLoading || isLoading}
        onClick={handleClick}
      />
      {renderModals()}
    </>
  );
};
